<div class="button-group">
    <button
        i18n
        [disabled]="state.roundState.phase === AppPhase.WaitingForCroupier || state.roundState.phase === AppPhase.ShoeChange"
        class="button-game button-game-small button-small-padding"
        (click)="actionClicked.emit({ button: voidGameChangeShowButton, action: DealerConsoleAction.ChangeShoe })"
        #voidGameChangeShowButton
    >
        Void game and change shoe
    </button>

    <!-- Not yet implemented on backend -->
    <button
        i18n
        [disabled]="true"
        class="button-game button-game-small button-small-padding"
        (click)="actionClicked.emit({ button: voidButton, action: DealerConsoleAction.ChangeShoe })"
        #voidButton
    >
        Void game
    </button>
</div>
<button
    i18n
    [disabled]="state.roundState.phase !== AppPhase.DealingCards"
    class="button-game button-game-small"
    (click)="actionClicked.emit({ button: changeResultButton, action: DealerConsoleAction.ChangeResult })"
    #changeResultButton
>
    Change result
</button>
<div class="button-group">
    <button
        i18n
        [disabled]="state.roundState.phase === AppPhase.ShoeChange"
        class="button-game button-game-small"
        (click)="actionClicked.emit({ button: changeGameButton, action: DealerConsoleAction.ChangeGame })"
        #changeGameButton
    >
        Change game
    </button>

    <button
        i18n
        [disabled]="state.flagsState.tableClosingRequested"
        class="button-game button-game-small"
        [class.button-game-highlight]="state.flagsState.tableClosingRequested"
        (click)="actionClicked.emit({ button: closeTableButton, action: DealerConsoleAction.CloseTable })"
        #closeTableButton
    >
        Close table
    </button>
</div>
